exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ConfigChangeTracker {\n  display: inline-block; }\n  .ConfigChangeTracker .itemDiv {\n    margin-top: 10px; }\n  .ConfigChangeTracker .controlLabel {\n    margin-right: 5px; }\n  .ConfigChangeTracker .reasonSelect {\n    box-sizing: border-box;\n    border: 1px solid #51AFE8;\n    border-radius: 10px;\n    background-color: #f8f8f8;\n    font-size: 16px;\n    font-family: 'Open Sans', sans-serif;\n    transition: all 0.5s ease; }\n  .ConfigChangeTracker .textArea {\n    width: 450px;\n    height: 100px;\n    padding: 12px 20px;\n    box-sizing: border-box;\n    border: 1px solid #51AFE8;\n    border-radius: 10px;\n    background-color: #f8f8f8;\n    font-size: 16px;\n    font-family: 'Open Sans', sans-serif;\n    transition: all 0.5s ease; }\n  .ConfigChangeTracker .textArea:hover {\n    border-color: #199af6;\n    box-shadow: 0 0 5px #199af6; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/style/ConfigChangeTracker.scss
// module id = 1705
// module chunks = 0